import { render, staticRenderFns } from "./LegendEntry.vue?vue&type=template&id=b1ef9a32&scoped=true&"
import script from "./LegendEntry.vue?vue&type=script&lang=js&"
export * from "./LegendEntry.vue?vue&type=script&lang=js&"
import style0 from "./LegendEntry.vue?vue&type=style&index=0&id=b1ef9a32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ef9a32",
  null
  
)

export default component.exports